
import React, { useEffect, useState } from 'react';
import { api_bd_nr } from '../../services/Api.js';
import { Trash2, CheckCheck } from 'lucide-react'
import Consensus from './Consensus.js';
import InfractionsListComponent from './InfractionsListComponent.js';
import BonusesListComponent from './BonusesListComponent.js';

const Form = (props) => {
    const d = new Date()
    const [valueInfraction, setValueInfraction] = useState({})
    const [btnDisabled, setBtnDisabled] = useState(false)
    const [data, setData] = useState(props.data)
    const [valuerNote, setValuerNote] = useState('')

    const [infractionsList, setInfractionsList] = useState([])
    const [bonificationList, setBonificationList] = useState([])
    const [formOption, setFormOption] = useState('')

    // const infractionsList = [
    //     {
    //         name: "Selecione uma infração",
    //         desc: "Selecione uma infração",
    //         point: 0
    //     },
    //     {
    //         name: "Não execução de ticket",
    //         desc: "Não execução de ticket",
    //         point: -10
    //     },
    //     {
    //         name: "Execução sem inserção de informações",
    //         desc: "Execução sem inserção de informações",
    //         point: -5
    //     },
    //     {
    //         name: "Reclamação justificada",
    //         desc: "Reclamação justificada",
    //         point: -15
    //     },
    //     {
    //         name: "Reclamação grave",
    //         desc: "Reclamação grave",
    //         point: -30
    //     },
    //     {
    //         name: "Não Cumprimento de TME (violação leve)",
    //         desc: "Não Cumprimento de TME (violação leve)",
    //         point: -2
    //     },
    //     {
    //         name: "Não Cumprimento de TME (violação grave)",
    //         desc: "Não Cumprimento de TME (violação grave)",
    //         point: -4
    //     },
    //     {
    //         name: "Feedback Negativo de Colegas",
    //         desc: "Feedback Negativo de Colegas",
    //         point: -4
    //     },
    //     {
    //         name: "Feedback Negativo de Colegas (justificado)",
    //         desc: "Feedback Negativo de Colegas (justificado)",
    //         point: -8
    //     },
    //     {
    //         name: "Erros em Procedimentos (erro leve)",
    //         desc: "Erros em Procedimentos (erro leve)",
    //         point: -7
    //     },
    //     {
    //         name: "Erros em Procedimentos (erro grave)",
    //         desc: "Erros em Procedimentos (erro grave)",
    //         point: -15
    //     },
    //     {
    //         name: "Falha de atualização de documentação",
    //         desc: "Falha de atualização de documentação",
    //         point: -10
    //     },
    //     {
    //         name: "Desempate (-1)",
    //         desc: "Opção para desempate (-1)",
    //         point: -1
    //     },
    // ]

    const loadInfractionsList = () => {
        api_bd_nr.get('/performance-radar?q=infractionslist')
            .then(({ data }) => {
                setInfractionsList(data)
            })
            .catch(e => {
                console.log('error to load infractions list: ', e)
            })
    }
    const loadBonificationList = () => {
        api_bd_nr.get('/performance-radar?q=bonificationslist')
            .then(({ data }) => {
                // console.log(data)
                setBonificationList(data)
            })
            .catch(e => {
                console.log('error to load bonification list: ', e)
            })
    }

    useEffect(() => {
        loadInfractionsList()
        loadBonificationList()
    }, [])


    return (
        <div className='flex flex-col flex-wrap min-h-[80dvh] max-h[95dhv] justify-start items-center overflow-y-auto'>
            <>
                {props.loggedUser.nivel.match(/Super|Técnico-Admin/) &&
                    <div className='w-full relative' style={{ maxHeight: 270, minHeight: 170, marginBottom: formOption === '' ? 0 : 70 }}>
                        <div className='flex relative flex-col mb-6'>
                            <p className='font-bold text text-[1.2em]'>Adicionar infração</p>

                            <p className='mt-2'>
                                Nome: <b>{data?.name}</b><br />
                                Pontuação: <b>{String((data?.infractions.reduce((acc, currentData) => { return (acc + currentData?.point) }, 100) + data?.bonuses.reduce((acc, currentData) => { return (acc + currentData?.point) }, 0))).padStart(2, '0')}</b><br />
                                Qauntidade de infrações: <b>{String(data?.infractions?.length || 0).padStart(2, '0')}</b>
                            </p>

                            <button
                                className='mt-2 p-2 bg-blue-900 text-white rounded font-bold'
                                onClick={() => {
                                    setFormOption('bonification')
                                }}
                            >
                                Adicionar uma bonificação
                            </button>

                            <button
                                className='mt-2 p-2 bg-blue-900 text-white rounded font-bold'
                                onClick={() => {
                                    setFormOption('infraction')
                                }}
                            >
                                Adicionar uma infração
                            </button>

                            {formOption === 'bonification' &&
                                <>
                                    <select
                                        className='mt-4 p-2 m-0 border rounded'
                                        value={JSON.stringify(valueInfraction)}
                                        onChange={(e) => {
                                            if (e.target.value === '') {
                                                return
                                            }
                                            setValueInfraction(JSON.parse(e.target.value))
                                        }}
                                    >
                                        {bonificationList?.length === 0 &&
                                            <option value=''>Carregando lista de bonificações...</option>
                                        }

                                        {bonificationList?.map((el, index) => (
                                            <option key={`bonif_${index}`} value={JSON.stringify(el)}>{el.name}</option>
                                        ))}
                                    </select>

                                    <textarea
                                        className='mt-2 border rounded'
                                        placeholder='Observação sobre a pontuação'
                                        style={{
                                            padding: 10,
                                            height: 80,
                                            minHeight: 80
                                        }}
                                        onChange={(e) => {
                                            setValuerNote(e.target.value)
                                        }}
                                    >
                                        {valuerNote}
                                    </textarea>

                                    <button
                                        className='mt-2 p-2 bg-blue-900 text-white rounded font-bold'
                                        onClick={() => {
                                            if (valueInfraction.name === 'Selecione uma bonificação') {
                                                return alert('Selecione uma bonificação')
                                            }

                                            if (valuerNote === '') {
                                                return alert('Adicione uma observação sobre a bonificação')
                                            }

                                            if (valuerNote.length < 5) {
                                                return alert('Observação sobre a bonificação muito pequena, adicione uma observação maior')
                                            }


                                            setBtnDisabled(true)
                                            const month = props?.selectedMonth || String(d.getMonth() + 1).padStart(2, '0')
                                            const year = d.getFullYear()
                                            api_bd_nr.put(`/performance-radar/points?type=b&id=${props.data.id}`, {
                                                month,
                                                year,
                                                noteDesc: {
                                                    ...valueInfraction,
                                                    valuerNote,
                                                    valuer: {
                                                        name: props.loggedUser.nome,
                                                        level: props.loggedUser.nivel,
                                                        id: props.loggedUser.id,
                                                    }
                                                }
                                            })
                                                .then((resp) => {
                                                    // console.log('resp.data', resp.data)
                                                    const userData = resp.data.participants.find(el => el.id === data.id)
                                                    // console.log('userData: ', userData)
                                                    setData({
                                                        ...userData,
                                                        bonuses: [
                                                            ...userData.bonuses,
                                                            {
                                                                ...valueInfraction, valuerNote,
                                                                valuer: {
                                                                    name: props.loggedUser.nome,
                                                                    level: props.loggedUser.nivel,
                                                                    id: props.loggedUser.id
                                                                }
                                                            }
                                                        ]
                                                    })
                                                    setBtnDisabled(false)
                                                    setValueInfraction(JSON.stringify({
                                                        name: "Selecione uma bonificação",
                                                        desc: "Selecione uma bonificação",
                                                        point: 0
                                                    }))
                                                    if (props.refreshData) {
                                                        props.refreshData()
                                                    }
                                                })
                                                .catch(e => {
                                                    setBtnDisabled(false)
                                                    console.log('update error: ', e)
                                                })
                                            // console.log({ ...props.data, month, year, valueInfraction })
                                        }}
                                    >Salvar</button>
                                </>
                            }

                            {formOption === 'infraction' &&
                                <>
                                    <select
                                        className='mt-4 p-2 m-0 border rounded'
                                        value={JSON.stringify(valueInfraction)}
                                        onChange={(e) => {
                                            if (e.target.value === '') {
                                                return
                                            }
                                            setValueInfraction(JSON.parse(e.target.value))
                                        }}
                                    >
                                        {infractionsList?.length === 0 &&
                                            <option value=''>Carregando lista de infrações...</option>
                                        }

                                        {infractionsList.map((el, index) => (
                                            <option key={`infr_${index}`} value={JSON.stringify(el)}>{el.name}</option>
                                        ))}
                                    </select>

                                    <textarea
                                        className='mt-2 border rounded'
                                        placeholder='Observação sobre a pontuação'
                                        style={{
                                            padding: 10,
                                            height: 80,
                                            minHeight: 80
                                        }}
                                        onChange={(e) => {
                                            setValuerNote(e.target.value)
                                        }}
                                    >
                                        {valuerNote}
                                    </textarea>

                                    <button
                                        className='mt-2 p-2 bg-blue-900 text-white rounded font-bold'
                                        onClick={() => {
                                            if (valueInfraction.name === 'Selecione uma infração') {
                                                return alert('Selecione uma infração')
                                            }

                                            if (valuerNote === '') {
                                                return alert('Adicione uma observação sobre a infração')
                                            }

                                            if (valuerNote.length < 5) {
                                                return alert('Observação sobre a infração muito pequena, adicione uma observação maior')
                                            }


                                            setBtnDisabled(true)
                                            const month = props?.selectedMonth || String(d.getMonth() + 1).padStart(2, '0')
                                            const year = d.getFullYear()
                                            api_bd_nr.put(`/performance-radar/points?type=i&id=${props.data.id}`, {
                                                month,
                                                year,
                                                noteDesc: {
                                                    ...valueInfraction,
                                                    valuerNote,
                                                    valuer: {
                                                        name: props.loggedUser.nome,
                                                        level: props.loggedUser.nivel,
                                                        id: props.loggedUser.id,
                                                    }
                                                }
                                            })
                                                .then((resp) => {
                                                    // console.log('resp.data', resp.data)
                                                    const userData = resp.data.participants.find(el => el.id === data.id)
                                                    // console.log('userData: ', userData)
                                                    setData({
                                                        ...userData,
                                                        infractions: [
                                                            ...userData.infractions,
                                                            {
                                                                ...valueInfraction, valuerNote,
                                                                valuer: {
                                                                    name: props.loggedUser.nome,
                                                                    level: props.loggedUser.nivel,
                                                                    id: props.loggedUser.id
                                                                }
                                                            }
                                                        ]
                                                    })
                                                    setBtnDisabled(false)
                                                    setValueInfraction(JSON.stringify({
                                                        name: "Selecione uma infração",
                                                        desc: "Selecione uma infração",
                                                        point: 0
                                                    }))
                                                    if (props.refreshData) {
                                                        props.refreshData()
                                                    }
                                                })
                                                .catch(e => {
                                                    setBtnDisabled(false)
                                                    console.log('update error: ', e)
                                                })
                                            // console.log({ ...props.data, month, year, valueInfraction })
                                        }}
                                    >Salvar</button>
                                </>
                            }
                        </div>
                    </div>
                }
            </>

            <div className='w-full'>
                {/* <details
                    className='w-full pb-4 border-b-[1px] border-b-gray-400 details-wrapper'
                    style={{ justifySelf: 'flex-start' }}
                >
                    <summary className='text-[1.2em]'>{data?.infractions?.length > 0 ? <><b>Lista de infrações  ({String(data?.infractions?.length).padStart(2, '0')})</b></> : <b>Nenhuma infração registrada para este usuário</b>}</summary>
                    <div className='space-y-6 w-full' style={{ overflowY: 'auto', position: 'relative' }}>
                        {data?.infractions?.map((el, index) => (
                            <div key={`summary_${index}`} className='flex space-x-4 flex-row w-full h-full  bg-slate-100 rounded'>
                                <div className='h-full w-full'>
                                    <p className='mt-2 flex flex-col'>
                                        <span style={{ textWrap: 'wrap' }}>Infração: <b>{el?.name}</b></span>
                                        <span style={{ textWrap: 'wrap' }}>Pontuação: <b>{el?.point}</b></span>
                                        <span style={{ textWrap: 'wrap' }}>Data: <b>{el?.date ? new Date(el?.date)?.toLocaleDateString() : new Date()?.toLocaleDateString()}</b></span>
                                        <span style={{ textWrap: 'wrap' }}>Observação: <b>{el?.valuerNote}</b></span>
                                        {el?.consensus?.active &&
                                            <span style={{ textWrap: 'wrap' }}>Consenso: <b>{el?.consensus?.obs}</b></span>
                                        }
                                        {props.loggedUser.nivel.match(/Super|Técnico-Admin/) &&
                                            <span style={{ textWrap: 'wrap' }}>Avaliador: <b>{el?.valuer?.name}</b></span>
                                        }
                                    </p>
                                </div>

                                {(el?._id && (props.loggedUser.nivel.match(/Super|Técnico-Admin/))) &&
                                    <div className='flex flex-grow flex-col pr-4 space-y-1 justify-around items-center min-w-[80px] max-w-[80px] h-auto'>
                                        <button
                                            className={`flex justify-center w-[80px] px-4 py-1 ${el?.consensus?.active ? ' bg-green-700' : ' bg-blue-900'} text-white rounded font-bold cursor-pointer`}
                                            onClick={() => {
                                                if (props?.openModal2) {
                                                    props.openModal2(<Consensus
                                                        data={el}
                                                        loggedUser={props.loggedUser}
                                                        onSave={(val) => {
                                                            const { active, obs, point, valuer } = val

                                                            // const dataWithConsensus = {
                                                            //     ...data,
                                                            //     infractions: data.infractions.map(infraction => {
                                                            //         if (infraction._id === el._id) {
                                                            //             return ({
                                                            //                 ...infraction,
                                                            //                 point,
                                                            //                 consensus: { active, obs, valuer }
                                                            //             })
                                                            //         }
                                                            //     })
                                                            // }
                                                            // console.log('dataWithConsensus', dataWithConsensus)

                                                            const month = props?.selectedMonth || String(d.getMonth() + 1).padStart(2, '0')
                                                            const year = d.getFullYear()
                                                            api_bd_nr.put(`/performance-radar/consensus?id=${el._id}`, {
                                                                month,
                                                                year,
                                                                point,
                                                                consensus: { active, obs, valuer },
                                                            })
                                                                .then(({ data }) => {
                                                                    setData(current => {
                                                                        return ({
                                                                            ...current,
                                                                            infractions: current.infractions.map(infraction => {
                                                                                if (infraction._id === el._id) {
                                                                                    return ({
                                                                                        ...infraction,
                                                                                        point,
                                                                                        consensus: { active, obs, valuer }
                                                                                    })
                                                                                } else {
                                                                                    return infraction
                                                                                }
                                                                            })
                                                                        })
                                                                    })
                                                                    if (props.refreshData) {
                                                                        props.refreshData()
                                                                    }
                                                                    // alert("Erro ao adicionar o consenso, tente novamente, se o erro persistir contate o suporte")
                                                                })
                                                                .catch((e) => {
                                                                    alert("Erro ao adicionar o consenso, tente novamente, se o erro persistir contate o suporte")
                                                                    console.log('update consensus error: ', e)
                                                                })
                                                            if (props?.closeModal2) {
                                                                props.closeModal2()
                                                            }
                                                        }}
                                                    />)
                                                }
                                            }}
                                        >
                                            <CheckCheck />
                                        </button>
                                        <button
                                            className='flex justify-center  w-[80px] px-4 py-1  bg-blue-900 text-white rounded font-bold cursor-pointer'
                                            onClick={() => {
                                                if (window.confirm('Deseja remover esta infração?')) {
                                                    api_bd_nr.delete(`/performance-radar/points?id=${el._id}`)
                                                        .then((resp) => {
                                                            const temp = {
                                                                ...data,
                                                                infractions: data?.infractions.filter(ell => ell._id !== el._id)
                                                            }
                                                            setData(temp)

                                                            alert('Ação realizada com sucesso!')
                                                            if (props.refreshData) {
                                                                props.refreshData()
                                                            }
                                                        })
                                                        .catch(e => {
                                                            setBtnDisabled(false)
                                                            console.log('delete error: ', e)
                                                        })
                                                }
                                            }}
                                        >
                                            <Trash2 />
                                        </button>
                                    </div>
                                }
                            </div>
                        ))}
                    </div>
                </details> */}
                <InfractionsListComponent
                    d={d}
                    data={data}
                    setData={setData}
                    setBtnDisabled={setBtnDisabled}
                    loggedUser={props.loggedUser}
                    refreshData={props.refreshData}
                    openModal2={props.openModal2}
                    closeModal2={props.closeModal2}
                    selectedMonth={props.selectedMonth}
                />
            </div>
            <div className='w-full mt-[10px]'>
                <BonusesListComponent
                    d={d}
                    data={data}
                    setData={setData}
                    setBtnDisabled={setBtnDisabled}
                    loggedUser={props.loggedUser}
                    refreshData={props.refreshData}
                    openModal2={props.openModal2}
                    closeModal2={props.closeModal2}
                    selectedMonth={props.selectedMonth}
                />
            </div>

            <div className='mt-6 w-full space-y-6'>
                <p className='font-bold'>Detalhamento das infrações</p>
                <div className='w-full p-2 bg-slate-100 rounded'>
                    <p className='text-sm'><b>Trabalho não registrado: </b><br />
                        Não execução de ticket: <b>-10 pontos</b><br />
                        Execução sem inserção de informações: <b>-5 pontos</b>
                    </p>
                </div>

                <div className='w-full p-2 bg-slate-100 rounded'>
                    <p className='mt-2 text-sm'><b>Reclamações de Clientes: </b><br />
                        Reclamação justificada: <b>-15 pontos</b><br />
                        Reclamação grave (impacto significativo): <b>-30 pontos</b>
                    </p>
                </div>

                <div className='w-full p-2 bg-slate-100 rounded'>
                    <p className='mt-2 text-sm'><b>Não Cumprimento de TME (Ticket atribuído sem execução): </b><br />
                        Violação leve: <b>-2 pontos</b><br />
                        Violação grave: <b>-4 pontos</b>
                    </p>
                </div>

                <div className='w-full p-2 bg-slate-100 rounded'>
                    <p className='mt-2 text-sm'><b>Feedback Negativo de Colegas: </b><br />
                        Feedback negativo justificado: <b>-8 pontos</b>
                    </p>
                </div>

                <div className='w-full p-2 bg-slate-100 rounded'>
                    <p className='mt-2 text-sm'><b>Erros em Procedimentos no SGI: </b><br />
                        Erro leve: <b>-1 pontos</b><br />
                        Erro médio: <b>-3 pontos</b><br />
                        Erro grave: <b>-5 pontos.</b>
                    </p>
                </div>

                <div className='w-full p-2 bg-slate-100 rounded'>
                    <p className='mt-2 text-sm'><b>Erros em Procedimentos: </b><br />
                        Erro leve: <b>-7 pontos</b><br />
                        Erro grave: <b>-15 pontos.</b>
                    </p>
                </div>

                <div className='w-full p-2 bg-slate-100 rounded relative'>
                    <p className='mt-2 text-sm'><b>Falha de atualização de documentação (SGI, Grafana e Zabbix): </b><br />
                        Falta de atualização: <b>-10 pontos.</b>
                    </p>
                </div>


                <p style={{ marginTop: 50 }} className='font-bold'>Detalhamento das Bonificações</p>
                <div className='w-full p-2 bg-slate-100 rounded'>
                    <p className='text-sm'><b>Bonificação em relação a nota do cliente (3 pontos) </b></p>
                </div>
                <div className='w-full p-2 bg-slate-100 rounded'>
                    <p className='text-sm'><b>Bonificação por postagem na wiki (2 pontos ) </b></p>
                </div>
                <div className='w-full p-2 bg-slate-100 rounded'>
                    <p className='text-sm'><b>Bonificação feedback positivo por cliente (2 pontos ) </b></p>
                </div>



                <p style={{ marginTop: 50 }} className='font-bold'>Critérios de desempate</p>
                <div className='w-full p-2 bg-slate-100 rounded'>
                    <p className='mt-2 text-sm'><b>1 - Número de tickets finalizados</b><br /></p>
                </div>

                <div className='w-full p-2 bg-slate-100 rounded'>
                    <p className='mt-2 text-sm'><b>2 - Número de horas trabalhadas em sobreaviso</b><br /></p>
                </div>

                <div className='w-full p-2 bg-slate-100 rounded'>
                    <p className='mt-2 text-sm'><b>3 - Número de horas executadas nos tickets</b><br /></p>
                </div>

                <div className='w-full p-2 bg-slate-100 rounded'>
                    <p className='mt-2 text-sm'>
                        Se for identificada alguma irregularidade o analista será penalizado
                    </p>
                </div>

                <div className='w-full p-2 bg-slate-100 rounded'>
                    <p className='mt-2 text-sm'><b>Observação</b><br />
                        Ao final de cada mês todos os analistas poderão trazer a defesa de penalidades que forem consideradas injustas. Sempre com  base em evidências demonstradas
                    </p>
                </div>
            </div>

        </div>
    );
};

export default Form;
